document.addEventListener('DOMContentLoaded', () => {
  const template = document.querySelector('share-button.share-button');
  if (!template) return;

  const images = document.querySelectorAll('.article-template__content img.shareable-image');
  if (!images.length) return;

  const setLabelText = (el, text) => {
    if (!el) return;
    for (const node of el.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        node.textContent = ` ${text} `;
      }
    }
  };

  images.forEach((img, index) => {
    const clone = template.cloneNode(true);
    const uid = `image-${index}`;

    clone.id = `Share-${uid}`;
    clone.dataset.shareFileUrl = img.currentSrc || img.src;

    const details = clone.querySelector('details');
    if (details) details.id = `Details-${uid}`;

    const urlInput = clone.querySelector('input.field__input');
    const urlLabel = clone.querySelector('label.field__label');
    if (urlInput) urlInput.id = `ShareUrl-${uid}`;
    if (urlLabel && urlInput) urlLabel.setAttribute('for', urlInput.id);

    const message = clone.querySelector('.share-button__message');
    if (message) message.id = `ShareMessage-${uid}`;

    setLabelText(clone.querySelector('button.share-button__button'), 'Share this image');
    setLabelText(clone.querySelector('summary.share-button__button'), 'Share this image');

    img.insertAdjacentElement('afterend', clone);
  });
});